export const VehicleTypeField = ({ }) => {
    return <></>
}